export const VehicleTypeField = ({ }) => {
    return <></>
}